const getMeta = key=>document.querySelector(`meta[name="${key}"]`)?.getAttribute("content")
export const csrfFetch = (path, options : RequestInit = {}) => {
  let myOptions = Object.assign({}, options);
  if (options.method && options.method.toUpperCase() != 'GET') {
    myOptions.headers = new Headers(options.headers || {});
    myOptions.headers.set("X-CSRF-Token", getMeta('csrf-token'))
  }
  myOptions.mode = 'same-origin';
  myOptions.credentials = 'same-origin';
  return fetch(path, myOptions)
}
export const fetchJson = (path, options = {}) => {
  return csrfFetch(path, options).then(r=>r.json())
}
export const submitForm = form => {
  const path = form.action || location.href;
  const options = {
    method: (form.method || 'GET').toUpperCase(),
    cache: 'no-cache' as const,
    body: new FormData(form)
  }
  return csrfFetch(path, options);
}
export const submitFormJson = form => {
  return submitForm(form).then(r => r.json());
}
declare global {
  interface Window { newrelic: any; }
}
export const errorFn = options => {
  let { alert, report, alertFn } = options;
  return function (error) {
    const jsonApiError = error.errors?.[0]
    // Report via newrelic unless told not to. If this is an unexpected JSON:API
    // error, i.e. 5xx code, report even if told not to.
    if (report !== false || jsonApiError?.status?.startsWith("5")) {
      const attrs = (typeof report === "string") ? { context: report } : (report || {});
      window.newrelic?.noticeError(error, attrs);
      console.group("Unexpected error");
      console.log(error);
      if (Object.keys(attrs).length) console.log(attrs);
      console.groupEnd();
    }
    if (alert) {
      if (alert === true) {
        alert = jsonApiError?.detail || jsonApiError?.title || "Unexpected error. Please refresh the page and try again.";
      }
      (alertFn || window.alert)(alert);
    }
    return error;
  }
}
